import type { NavigationMenuItem } from '@nuxt/ui'

import { adminUsersPath } from '@/routes'

export interface AdminPage {
  label: string
  description: string
  icon: string
  to: string
}

export const adminPages = [
  {
    label: 'Accounts',
    description: 'Manage user accounts and permissions',
    icon: 'i-lucide-users',
    to: adminUsersPath(),
  },
] satisfies AdminPage[]

export function getAdminNavigationItems(currentUrl: string, onSelect?: () => void): NavigationMenuItem[] {
  return adminPages.map(item => ({
    label: item.label,
    icon: item.icon,
    to: item.to,
    active: currentUrl.startsWith(item.to),
    onSelect,
  }))
}
